import { PUBLIC_REDUCED_LAYOUT } from '@/constants/layouts'
import { FOOTER_COMPONENT_NAMES } from '@/components/public/footers/index'
import i18n from '@/plugins/i18n'
import { PRIMESALUD_PLATFORM_NAME } from '@/constants/platformNames'


const theme = 'opensaludprime'
const footer = {
  component: FOOTER_COMPONENT_NAMES.PRIMESALUD
}

const gtag = PRIMESALUD_PLATFORM_NAME

const i18nFile = 'public/views/primesalud'

export default [
  {
    path: '/',
    name: 'Opensaludprime',
    component: () => import('@/components/views/opensalud/Opensaludpass'),
    meta: {
      title: {
        text: 'Opensaludprime'
      },
      footer: {
        component: FOOTER_COMPONENT_NAMES.PRIMESALUD
      },
      i18n: 'public/views/primesalud',
      gtag,
      theme
    }
  },
  {
    path: 'mindfulness',
    name: 'Mindfulness',
    component: () => import('@/components/views/opensalud/MindfulnessPilatesDream'),
    meta: {
      title: {
        text: 'Mindfulness'
      },
      footer
    },
    i18n: 'public/views/Mindfulness',
    gtag,
    theme
  },
  {
    path: 'bienestar',
    name: 'Wellness',
    component: () => import('@/components/views/opensalud/landing/PrimesaludWellness'),
    meta: {
      title: {
        text () {
          return i18n.t('wellness.meta-title')
        }
      },
      footer,
      i18n: 'public/views/primesalud-wellness',
      gtag,
      theme
    }
  },
  {
    path: 'asistenciamedica',
    name: 'Medicalassistance',
    component: () => import('@/components/views/opensalud/landing/PrimesaludMedicalAssistance'),
    meta: {
      title: {
        text () {
          return i18n.t('medical-assistance.meta-title')
        }
      },
      footer,
      i18n: 'public/views/primesalud-medical-assistance',
      gtag,
      theme
    }
  },
  {
    path: 'descuentos',
    name: 'Discounts',
    component: () => import('@/components/views/opensalud/landing/PrimesaludDiscounts'),
    meta: {
      title: {
        text () {
          return i18n.t('discounts.meta-title')
        }
      },
      footer,
      i18n: 'public/views/primesalud-discounts',
      gtag,
      theme
    }
  },
  {
    path: 'gracias',
    name: 'ContactFormSuccessOpensaludPrime',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_REDUCED_LAYOUT,
      i18n: 'forms/companies-contact-form.json',
      gtag,
      theme
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/opensaludprime.routes.js